// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"7f0f6dd2","693":"fa84440f"}[chunkId] + ".chunk.js";
};